<template>
  <!-- Sidebar is desktop-only; on mobile the NavBar hamburger exposes these links. -->
  <aside class="hidden lg:block lg:w-64 flex-shrink-0">
    <nav class="lg:sticky card p-3" style="top: 5.5rem">
      <p
        class="text-xs font-bold uppercase tracking-wider text-ink-muted px-3 pt-2 pb-3"
      >
        Menu
      </p>
      <div class="space-y-1">
        <router-link
          v-for="link in links"
          :key="link.title"
          :to="{ name: link.routeName }"
          exact-active-class="is-active"
          class="menu-link group flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors text-ink-soft hover:bg-gray-50"
        >
          <font-awesome-icon
            :icon="link.icon"
            class="menu-ico w-4 text-center text-ink-muted"
          />
          <span>{{ link.title }}</span>
        </router-link>
      </div>
    </nav>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from 'store/auth'

export default {
  computed: {
    ...mapGetters({
      isAdmin: getterTypes.isAdmin,
    }),
    links() {
      const base = [
        { title: 'Projects', routeName: 'Dashboard', icon: 'folder-open' },
        {
          title: 'Data management',
          routeName: 'DataManagement',
          icon: 'tasks',
        },
      ]
      if (this.isAdmin) {
        base.push(
          { title: 'Users', routeName: 'UserManagement', icon: 'user' },
          { title: 'Audit log', routeName: 'AuditLog', icon: 'history' }
        )
      }
      base.push(
        { title: 'Export data', routeName: 'ExportData', icon: 'download' },
        { title: 'Support', routeName: 'Support', icon: 'info-circle' },
        { title: 'Settings', routeName: 'Settings', icon: 'cog' }
      )
      return base
    },
  },
}
</script>

<style scoped>
.menu-link:hover {
  color: #831f82;
}
.menu-link:hover .menu-ico {
  color: #831f82;
}
.menu-link.is-active {
  background-color: #fbf4fb;
  color: #831f82;
}
.menu-link.is-active .menu-ico {
  color: #831f82;
}
</style>
